var exports = {
  "kL": "x4ddf2309--706dae--container",
  "wx": "x4ddf2309--706dae--header",
  "zZ": "x4ddf2309--706dae--back-button",
  "DD": "x4ddf2309--706dae--title",
  "Qs": "x4ddf2309--706dae--content",
  "qr": "x4ddf2309--706dae--footer",
};

module.exports = exports;
